import { useApi } from '../hooks/useApi.js';
import { fetchEvents } from '../lib/api.js';
import { Seo } from '../components/Seo.jsx';
import { PageHeader } from '../components/PageHeader.jsx';
import { EventCard } from '../components/EventCard.jsx';
import { usePage } from '../hooks/usePage.js';

export function EventsPage() {
  const head = usePage('events');
  const { data: events, loading } = useApi(() => fetchEvents({ upcoming: 'true' }), []);

  return (
    <>
      <Seo title="Events" description={head.metaDescription} />

      <PageHeader
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Media & News' }, { label: 'Events' }]}
        headline={head.headline}
        lede={head.lede}
        image={head.banner}
      />

      <section>
        <div className="container">
          {loading && <p style={{ color: 'var(--ink-3)' }}>Loading events…</p>}
          {!loading && (events?.length ? (
            <div className="events" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 380px), 1fr))' }}>
              {events.map((e) => <EventCard key={e.id} item={e} />)}
            </div>
          ) : (
            <p style={{ color: 'var(--ink-3)', textAlign: 'center' }}>
              No upcoming events scheduled. Check back soon.
            </p>
          ))}
        </div>
      </section>
    </>
  );
}
